// ==========================================
// MODELOS DE NAVEGACIÓN
// ==========================================
// Interfaces y tipos para la configuración de menús de navegación
// Usados en los sidebars de todas las aplicaciones
// ==========================================

/**
 * Item de menú de navegación
 */
export interface NavMenuItem {
  /** Identificador único del item */
  id: string;

  /** Texto visible del menú */
  label: string;

  /** Ruta de navegación (puede ser relativa o absoluta) */
  route?: string;

  /** Icono del menú (emoji, clase CSS, o nombre de icono) */
  icon?: string;

  /** Nombre del icono (para usar con IconService) */
  iconName?: string;

  /** Items hijos para menús expandibles */
  children?: NavMenuItem[];

  /** Si el item está deshabilitado */
  disabled?: boolean;

  /** Si el item requiere permisos específicos */
  requiredPermissions?: string[];

  /** Badge con contador (ej: notificaciones) */
  badge?: {
    value: number | string;
    variant: 'primary' | 'secondary' | 'success' | 'warning' | 'error';
  };
}

/**
 * Configuración completa del menú de navegación
 */
export interface NavMenuConfig {
  /** Items principales del menú */
  items: NavMenuItem[];

  /** Título opcional del menú */
  title?: string;

  /** Si permite collapsar/expandir grupos */
  collapsible?: boolean;
}

/**
 * Secciones de menú agrupadas
 */
export interface NavMenuSection {
  /** Identificador de la sección */
  id: string;

  /** Título de la sección */
  title?: string;

  /** Items de esta sección */
  items: NavMenuItem[];
}
